import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServicesVisit";

const api_url = API_URL + API.RAPPORTS.GETRAPPORTS;

export const getRapports = createAsyncThunk(
  'rapports/getRapports',
  async ({ pageNumber, limit, filter }, thunkAPI) => {
    try {
      // Utilisons directement l'objet filter, c'est plus simple
      const params = new URLSearchParams({
        page: pageNumber,
        limit: limit,
        _t: Date.now() 
      });

      // Ajoute chaque filtre à la requête s'il a une valeur
      Object.keys(filter).forEach(key => {
        if (filter[key] !== undefined && filter[key] !== null && String(filter[key]).length > 0) {
          params.append(key, filter[key]);
        }
      });

      const queryString = params.toString();
      const response = await axiosService.get(`${api_url}?${queryString}`);
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

export const getRapportById = createAsyncThunk(
  'rapports/getRapportById',
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.get(`${api_url}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

export const deleteRapport = createAsyncThunk(
  'rapports/deleteRapport',
  async (rapportId, thunkAPI) => {
    try {
      const token = thunkAPI.getState().signin.token;

      if (!token) {
        throw new Error("Utilisateur non authentifié");
      }

      const deleteUrl = `${api_url}/${rapportId}`;

      const response = await axiosService.delete(deleteUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 204) {
        return rapportId;
      } else {
        // Renvoie une erreur avec des informations plus utiles
        return thunkAPI.rejectWithValue(`Erreur: ${response.status} ${response.statusText} - ${JSON.stringify(response.data)}`);
      }
    } catch (error) {
      // Renvoie une erreur avec des informations plus utiles
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message || "Erreur inconnue");
    }
  }
);

export const findDuplicateRapports = createAsyncThunk(
  'rapports/findDuplicates',
  async (_, thunkAPI) => {
    try {
      const response = await axiosService.get(`${api_url}/duplicates/find`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An error occurred while fetching duplicates');
    }
  }
);

export const addRapport = createAsyncThunk(
  'rapports/addRapport',
  async (rapportData, thunkAPI) => {
    try {
      // API.RAPPORTS.GETRAPPORTS pointe vers '/reports', c'est parfait pour un POST aussi
      const response = await axiosService.post(api_url, rapportData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Erreur lors de la création du rapport');
    }
  }
);